/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component, Inject, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {RegistryContexts} from "@app/models/constants/registry-constants";
import {hasActionsExecuting} from "@ngxs-labs/actions-executing";
import {Select, Store} from "@ngxs/store";
import {TrecTask} from "@trec/api/clinical-data";
import {C3SnackbarStatusService} from "@trec/components/snackbar-status";
import {StoreAction} from "@trec/components/store";
import {Observable} from "rxjs";
import {TpBaseActions} from "../../../store/patient-treatment-plan-base.actions";
import {CdItemFormComponent, CdItemFormMode} from "../../forms/cd-item-form-component";

export interface EditTaskDialogComponentData {
  context?: RegistryContexts[] | undefined;
  AI?: boolean;
  task: TrecTask;
  canEditOrDelete?: boolean
}

@Component({
  selector: "c3-edit-task-dialog",
  templateUrl: "./edit-task-dialog.component.html",
  styleUrls: ["./edit-task-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditTaskDialogComponent {
  editMode = false;
  isAI = false;
  @ViewChild('formItem', {static: false}) formItem!: any;

  @Select(
    hasActionsExecuting([
      TpBaseActions.FetchTasks,
      TpBaseActions.InsertTask,
      TpBaseActions.EditTask,
    ])
  )
  loading$: Observable<boolean>;

  // get mode(): CdItemFormMode {
  //   //console.log(this.data);
  //   return this.data.task ? (this.editMode ? "edit" : "view") : "insert";
  // }

  get mode(): CdItemFormMode {
    //console.log('get mode()')
    if (!this.data.task) {
      return 'insert';
    }

    if (this.data.AI) {
      this.editMode = true;
      this.isAI = true;
      return 'insertByAV';
    }

    return this.editMode ? 'edit' : 'view';
  }

  constructor(
    private store: Store,
    public dialogRef: MatDialogRef<EditTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditTaskDialogComponentData,
    private c3SnackbarStatus: C3SnackbarStatusService
  ) {
    if (!this.data.task) {
      this.editMode = true;
    }
  }

  onSubmit(formComp: CdItemFormComponent<TrecTask, any>) {
    //console.log('onSubmit');
    // Prepare item to submit
    const task = formComp.prepareData();
    ////console.log(task);
    if (!task) {
      return;
    }

    let action: StoreAction;
    let succMsg: string;

    switch (this.mode) {
      case "insert":
        action = new TpBaseActions.InsertTask({task});
        succMsg = `Task aggiunta correttamente`;
        break;
      case "insertByAV":
        action = new TpBaseActions.InsertTask({task});
        succMsg = `Task aggiunta correttamente mediante comando Assistente Vocale`;
        break;
      case "edit":
        action = new TpBaseActions.EditTask({task});
        succMsg = `Task modificata correttamente`;
        break;
      default:
        throw new Error(`Cannot do operation in mode ${this.mode}`);
    }

    // Perform action
    this.store.dispatch(action).subscribe(() => {
      this.c3SnackbarStatus.showSuccess({message: succMsg});
      this.dialogRef.close();
    });

  }
}


